import React, { useState, useEffect } from "react";
import { db } from "../../../../firebase";
import { ref, push, update } from "firebase/database";
import { Button, ModalFooter, Form, FormGroup, Label, Input, Row, Col, Spinner } from 'reactstrap';
import { errorToast, successToast } from "../../../common/toast";
import { validateForm } from "../../../common/commonFunction";

const AddNewPackages = ({ fetchPackages, setIsAddModel, editData }) => {
    const [formValue, setFormValue] = useState({
        planName: "",
        planDuration: "",
        noOfForms: "",
    });

    const [formErrors, setFormErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const formValidationSchema = {
        planName: {
            required: { message: "Plan name is required" },
        },
        noOfForms: {
            required: { message: "Number of forms is required" },
        },
        planDuration: {
            required: { message: "Plan duration is required" },
        },
    };

    const handleFormValidation = () => {
        const errors = validateForm(formValue, formValidationSchema);
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (handleFormValidation()) {
            setIsLoading(true);
            try {
                const payload = {
                    registrationDate: new Date().toISOString(),
                    ...formValue,
                };

                if (editData) {
                    const packageRef = ref(db, `packages/${editData.id}`); // Reference to the specific package
                    await update(packageRef, formValue);
                    successToast("Package updated successfully!");
                } else {
                    const packageRef = ref(db, "packages"); // Reference to the "packages" node
                    await push(packageRef, payload); // Add a new package
                    successToast("Package added successfully!");
                }

                setFormValue({
                    planName: "",
                    planDuration: "",
                    noOfForms: "",
                });

                fetchPackages();
                setIsAddModel(false);
            } catch (error) {
                errorToast("Error saving package: " + error.message);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const setValue = (key, value) => {
        setFormValue({ ...formValue, [key]: value });
    };

    useEffect(() => {
        if (editData) {
            setFormValue({
                planName: editData?.planName || "",
                planDuration: editData?.planDuration || "",
                noOfForms: editData?.noOfForms || "",
            });
        }
    }, [editData]);

    return (
        <div>
            <Form>
                <Row>
                    <Col lg={4} md={6} sm={12}>
                        <FormGroup>
                            <Label for="planName">Plan Name</Label>
                            <Input
                                type="text"
                                id="planName"
                                placeholder="Enter Plan Name"
                                value={formValue.planName}
                                onChange={(e) => setValue("planName", e.target.value)}
                                invalid={!!formErrors.planName}
                            />
                            {formErrors.planName && <span className="text-danger">{formErrors.planName}</span>}
                        </FormGroup>
                    </Col>

                    <Col lg={4} md={6} sm={12}>
                        <FormGroup>
                            <Label for="noOfForms">No of Forms</Label>
                            <Input
                                type="text"
                                id="noOfForms"
                                placeholder="Enter No Of Forms"
                                value={formValue.noOfForms}
                                onChange={(e) => setValue("noOfForms", e.target.value)}
                                invalid={!!formErrors.noOfForms}
                            />
                            {formErrors.noOfForms && <span className="text-danger">{formErrors.noOfForms}</span>}
                        </FormGroup>
                    </Col>

                    <Col lg={4} md={6} sm={12}>
                        <FormGroup>
                            <Label for="planDuration">Plan Duration</Label>
                            <Input
                                type="text"
                                id="planDuration"
                                placeholder="Enter Plan Duration"
                                value={formValue.planDuration}
                                onChange={(e) => setValue("planDuration", e.target.value)}
                                invalid={!!formErrors.planDuration}
                            />
                            {formErrors.planDuration && <span className="text-danger">{formErrors.planDuration}</span>}
                        </FormGroup>
                    </Col>
                </Row>

                <ModalFooter>
                    <Button color="primary" onClick={onSubmit} disabled={isLoading}>
                        {isLoading && <Spinner size="sm" className="me-2" />}
                        {editData ? "Update" : "Submit"}
                    </Button>
                    <Button color="secondary" onClick={() => setIsAddModel(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Form>
        </div>
    );
};

export default AddNewPackages;
